<template>
  <div>
    <div
      style="font-family: Titillium Web; line-height: 1; background: black"
      class="
        p-3
        ml-1
        mr-1
        
        shadow-lg
        rounded-lg
        animate__animated animate__fadeIn
      "
      :style="`${$store.state.data.layout.background_card2}`"
    >
      <!-- <router-link to="/projectadd">
        <button
          type="button"
          @click="$router.push('/projectadd')"
          class="float-right btn btn-sm btn-style9 float-right"
          style="
            margin-left: 5px;
            padding: 3px;
            padding-top: 0px;
            padding-bottom: 0px;
            background: rgb(11, 1, 1);
            background: linear-gradient(
              90deg,
              rgba(11, 1, 1, 0.7203256302521008) 3%,
              rgba(6, 1, 1, 0.7791491596638656) 99%
            );
          "
        >
          <span class="text-2xl typcn typcn-coffee"></span>
        </button>
      </router-link> -->
      <div class="row">
        <div class="col-6">
          <input
            type="text"
            id="search"
            name="search"
            class="form-control form-control-sm"
            placeholder="search"
            v-model="searchItem"
          />
        </div>
        <div class="col-6 text-right">
          Total : <button type="button"  class="btn btn-sm btn-style9  "
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
          >{{filteredData.length}}</button>
        </div>
        <div class="col-12">
          <br>
          <button type="button" @click="pilih=item;pembagiannya=100;pagination=1;" v-for="(item, index) in kategori" :key="index+'kategori'" class="btn btn-sm  ml-2 mt-1 text-xs p-1" :class="`${item==pilih?'btn-warning':'btn-dark'}`">{{item==''?"- ALL -":item}}</button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <!-- <br>
           <div class="float-right">
        <button
          type="button"
          @click="pagPrev"
          style="background: rgb(11,1,1);
background: linear-gradient(90deg, rgba(11,1,1,0.7203256302521008) 3%, rgba(6,1,1,0.7791491596638656) 99%);"
          class="btn btn-sm btn-primary"
        >Previous</button>
        <button
          type="button"
          @click="pagNext"
          style="background: rgb(11,1,1);
background: linear-gradient(90deg, rgba(11,1,1,0.7203256302521008) 3%, rgba(6,1,1,0.7791491596638656) 99%);"
          class="btn btn-sm btn-primary"
        >Next</button>
      </div>
           <button
              type="button"
              v-for="(item, index) in tombolPagination"
              @click="changePagination(item)"
              :key="index+'pagination2'"
              v-show="item<jumlahPagination+1"
              class="ml-2 btn btn-sm btn-dark rounded-circle"
              :class="{'bg-blue hover:bg-blue border-blue cursor-not-allowed text-red':item==pagination}"
              :disabled="item==pagination"
            >{{item}}</button> -->
        </div>
        <div class="col-sm-6 " v-for="(item, index) in filteredData" :key="index">
          <router-link
          style="text-decoration:none;color:black;"
            :to="`/a-1/project/${item.judul.toLowerCase().split(' ').join('-')}-${
              item.id
            }`"
          >
            <div
              class="
                shadow
                rounded-lg
                p-2
                mt-3
                anim
                hover:bg-yellow-200
                cursor-pointer
                bg-white
              "
              style="min-height: 380px; box-shadow: 2px 2px 3px 1px"
            >
              <div class="text-center p-3">
                <img
                  :src="item.gambar"
                  :key="item.gambar"
                  class="mx-auto kinoLightBox img-fluid rounded-lg shadow-lg"
                  style="height: 250px"
                />
              </div>

              <p class="pl-2 font-bold text-capitalize" style="font-size: 14px">
                {{ item.judul }}
              </p>
              <button type="button"  class="btn btn-sm btn-style9 text-xs " 
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"
              style="position:absolute;right:20px;bottom:20px;font-size:10px;">{{item.type}}</button>
            </div>
          </router-link>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
               <div v-observe-visibility="visibilityChanged" >...</div>
            <!-- <br />
            <br />
            <button
              type="button"
              v-for="(item, index) in tombolPagination"
              @click="changePagination(item)"
              :key="index+'pagination2'"
              v-show="item<jumlahPagination+1"
              class="ml-2 btn btn-sm btn-dark rounded-circle"
              :class="{'bg-blue hover:bg-blue border-blue cursor-not-allowed text-red':item==pagination}"
              :disabled="item==pagination"
            >{{item}}</button> -->
          </div>
        </div>
      </div>
      <div class="float-right">
        <!-- <button
          type="button"
          @click="pagPrev"
          style="background: rgb(11,1,1);
background: linear-gradient(90deg, rgba(11,1,1,0.7203256302521008) 3%, rgba(6,1,1,0.7791491596638656) 99%);"
          class="btn btn-sm btn-primary"
        >Previous</button>
        <button
          type="button"
          @click="pagNext"
          style="background: rgb(11,1,1);
background: linear-gradient(90deg, rgba(11,1,1,0.7203256302521008) 3%, rgba(6,1,1,0.7791491596638656) 99%);"
          class="btn btn-sm btn-primary"
        >Next</button> -->
      </div>
    </div>
    <h1 style="font-size: 1px; opacity: 0.1">
      Project TA_Maliki / Taufik Akbar Maliki my project PORTOFOLIO WEBSITE
      OFFICIAL
    </h1>
  </div>
</template>
<script>
import axios from 'axios'
import autophp from '~/plugins/autophp.js'
import _ from 'lodash'
let urlnya='https://gis.officialapp.my.id'
let sdb = new autophp()
export default {
  data() {
    return {
      datanya: '',
      pilih: '',
      visible: 5,
      kategoris:[],
      temp1: 0,
      temp2: 10,
      pagination: 1,
      pembagiannya: 10,
      orderBy: '',
      orderWith: true,
      searchItem: '',
      kategori: ['','WEB','ANDROID/IOS','IOT','DESKTOP','PWA','SIDE-PROJECT','AUTOMATION','OTHER',]
    }
  },
  layout: 'a-1',
  computed: {
    jumlahPagination () {
      let data = this.datanya
      return data.length / 10
    },
    tombolPagination () {
      let data = this.pagination
      // v-if != (current > max ) button nya
      let btn1 = data - 2
      let btn2 = data - 1
      let btn3 = data
      let btn4 = data + 1
      let btn5 = data + 2
      let array = [btn1, btn2, btn3, btn4, btn5]
      if (array.indexOf(-1) != -1) {
        array = [1, 2, 3, 4, 5]
      } else if (array.indexOf(0) != -1) {
        array = [1, 2, 3, 4, 5]
      }
      return array
    },
    filteredData () {
      let that = this
      let data = this.datanya
      //! order fungsi
      if (this.orderBy.length > 0) {
        data = this.$_.orderBy(data, ['title'], [this.orderBy])
      }
      //! search fungsi
      if (data[0] != undefined) {
        let keys = Object.keys(data[0])
        data = data.filter((v, i, a) => {
          let hasil = false
          keys.filter((key) => {
            if (typeof v[key] === 'string') {
              if (
                v[key].toLowerCase().indexOf(this.searchItem.toLowerCase()) !=
                -1
              ) {
                hasil = true
              }
            } else {
              if (v[key] != undefined) {
                if (v[key].toString().indexOf(this.searchItem) != -1) {
                  hasil = true
                }
              }
            }
          })
          if (hasil) return v
        })
        // data = data.slice(this.temp1, this.temp2)
        data = data.filter((v, i, a) => {
          let hasil = false
          console.log(v.type == that.pilih)
          if (v['type'] == this.pilih) {
            return v
          } else if (this.pilih == '') {
            return v
          }
        })
      }
      // data = data.map(e => {
      //   let obj = {};
      //   let kunci = Object.keys(e);
      //   kunci = that.$_.difference(kunci, that.unless);
      //   kunci.forEach((a, index) => {
      //     if (kunci.find(e => e == that.date[index])) {
      //     } else {
      //       // obj[a] = 'tanggal'
      //     }
      //     console.log(typeof e[a]);
      //     obj[a] =
      //       typeof e[a] != "string"
      //         ? e[a]
      //         : new Date(e[a]) !== "Invalid Date" && !isNaN(new Date(e[a]))
      //         ? that.format(e[a])
      //         : e[a];
      //   });
      //   return obj;
      // });

      return data
    }
  },
  methods: {
     visibilityChanged(data){
            // console.log(data)
             this.visible=this.visible+100;
        },
    tes() {
      let data =
        this.datanya[0].judul.toLowerCase().split(' ').join('-') +
        '-1'.split('-')
      console.log(data[data.length - 1])
    },
    pagPrev() {
      this.pembagiannya=10;
      this.pagination = this.pagination - 1
      if (this.pagination == 0) {
        this.pagination = 1
      }
      this.temp2 = this.pagination * this.pembagiannya
      this.temp1 = Math.ceil(this.temp2) - this.pembagiannya
    },
    pagNext() {
      this.pembagiannya=10;
      this.pagination = this.pagination + 1
      if (this.pagination > this.jumlahPagination + 1) {
        this.pagination = Math.ceil(this.jumlahPagination)
      }
      this.temp2 = this.pagination * this.pembagiannya
      this.temp1 = Math.ceil(this.temp2) - this.pembagiannya
    },
    changePagination(pag) {
      this.pembagiannya=10;
      this.pagination = pag
      this.temp2 = this.pagination * this.pembagiannya
      this.temp2 = Math.ceil(this.temp2)
      this.temp1 = this.temp2 - this.pembagiannya
      this.temp1 = Math.ceil(this.temp1)
    },
  },
  mounted () {
       sdb
          .collection('app_portofolio_project',false,urlnya)
          .doc()
          .select(`select * from app_portofolio_project where iduser='${this.$store.state.id}'`)
          .then((res) => {
            console.log(res)
            let datas = res;
            datas=datas.map(e=>{
                return {
                  ...e,
                  urutan:parseInt(e.urutan)
                }
              })
          datas = _.orderBy(datas, 'urutan', 'asc');
            this.datanya = datas
            this.$forceUpdate()
          })
          
          sdb.collection("app_portofolio_project_kategori",false,urlnya).doc().select(`select * from app_portofolio_project_kategori`).then(res => {
              console.log(res);
              res=res.map(e=>{
                return e.kategori
              })
              this.kategori=res;
              this.kategori.unshift('');
              this.$forceUpdate();
          });
          
    },
}
</script>
